// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ta-lf {\r\n\ttext-align: left;\r\n\tdisplay: inline-block;\n}\n.mg-bt-0 {\r\n\tmargin-bottom: 0px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
